<pr-breadcrumb [links]="breadcrumb"></pr-breadcrumb>
<div class="pr-page-title">
  @if (optimizationType === 'LOAN_INSURANCE_RATE') {
    <h1>
      Vous pouvez <span class="text-blue">{{ title }}</span
      ><br />
      <span class="no-display-mobile text-blue">{{ subTitle }}</span>
      <p class="mt-10">
        Sur votre crédit
        @if (optimizationLabel) {
          <span> {{ optimizationLabel }}</span>
        }
        , En choisissant aujourd’hui la solution de changement d'assurance
        emprunteur Albr sélectionnée avec soin par nos experts courtiers
      </p>
    </h1>
  }
  @if (optimizationType === 'LOAN_INTEREST_RATE') {
    <h1>
      Vous pouvez <span class="text-blue">{{ title }}</span
      ><br />
      <span class="no-display-mobile text-blue">{{ subTitle }}</span>
      <p class="mt-10">
        Sur votre crédit
        @if (optimizationLabel) {
          <span> {{ optimizationLabel }}</span>
        }
        , En choisissant aujourd’hui la solution de refinancement Albr
        sélectionnée avec soin par nos experts courtiers
      </p>
    </h1>
  }
  @if (optimizationType === 'BUY_OR_RENT') {
    <h1>
      <span class="text-blue">Acheter ou louer</span><br />
      <span>votre résidence principale</span>
      <p class="mt-10">
        Découvrez si il est plus rentable, en fonction du coût immobilier dans
        votre secteur, d’acheter ou de louer votre résidence principale
      </p>
    </h1>
  }
  <ng-content></ng-content>
</div>
@if (menus) {
  <pr-page-header-menu
    class="no-display-mobile"
    [menus]="menus"
  ></pr-page-header-menu>
}
